import * as Cookies from 'es-cookie'

import HttpClient from '@/common/lib/http-client'
import { BaseResponse } from '@/common/models/responses/base'
import { IHot17IndexResponse, Hot17IndexResponse } from '@/common/models/responses/hot17-index-response'
import { Hot17VoteResponse } from '@/common/models/responses/hot17-vote-response'

import { hot17 as Api } from '@/app/api'

class Hot17Repository {
    private uidCookieName = 'hot17-uid'

    async all (): Promise<Hot17IndexResponse> {
        const response = await HttpClient.getJson<IHot17IndexResponse>(Api.index)

        return new Hot17IndexResponse(response)
    }

    async reset (): Promise<boolean> {
        const response = await HttpClient.postJson<BaseResponse>(Api.reset, {
            userid: Cookies.get(this.uidCookieName)
        })

        return response.status === 'success'
    }

    async vote (votes: Array<number>): Promise<boolean> {
        const response = await HttpClient.postJson<Hot17VoteResponse>(Api.vote, {
            userid: Cookies.get(this.uidCookieName),
            votes: votes
        })

        Cookies.set(this.uidCookieName, response.uid, {
            expires: 60 * 60 * 24 * 7,
            path: '/'
        })

        return response.status === 'success'
    }
}

export default new Hot17Repository()
